import { Col, Row, Space, Typography } from 'antd'
import ChilizNFTLogo from '../assets/images/logo.png'
import { ReactComponent as DiscordIcon } from '../assets/icons/DiscordIcon.svg'
import { ReactComponent as TwitterIcon } from '../assets/icons/TwitterIcon.svg'
import { NavLink } from 'react-router-dom'
import { ConnectionIndicator } from './ConnectionIndicator'
import { SelectChain } from './SelectChain'
import { chains, IChainConfig } from '../config/chains'
import Icon from '@ant-design/icons'
import { ReactComponent as ConnectIconSvg } from '../assets/icons/Connect.svg'
import { useState } from 'react'
import { useChilizConfigProvider, useChilizStore } from '../stores'
import { Header } from 'antd/es/layout/layout'
import { observer } from 'mobx-react'

const { REACT_APP_TWITTER_URL, REACT_APP_DISCORD_URL } = process.env

export const NFTHeader = observer((): JSX.Element => {
  const configProvider = useChilizConfigProvider()
  const store = useChilizStore()
  const [isMobileMenu] = useState(false)
  const onChangeChain = async (chainId): Promise<void> => {
    await store.addNetworkToMetaMask(chains.find(chain => chain.chainId === chainId) as IChainConfig)
  }
  return (
    <Header className="header"
            style={{ position: 'fixed', zIndex: 1, width: '100%', padding: isMobileMenu ? '0' : '0 10%' }}>
      <Row justify="space-between" align={'middle'} className={'header-row'} style={{ paddingBottom: '10px' }}>
        <Col>
          <Row gutter={{ xs: 5, sm: 16, md: 20, lg: 32 }} align={'middle'}>
            <Col>
              <NavLink to={''} rel="noreferrer"><img src={ChilizNFTLogo} alt="Chiliz NFTs" style={{ height: '4rem' }} /></NavLink>
            </Col>
          </Row>
        </Col>
        <Col style={{ justifyContent: 'flex-end' }}>
          <Row justify="space-between">
            <Space size={'middle'}>
              <Col>
                <Row>
                  <Space>
                    <Col><a className={'menu-link'} href={REACT_APP_DISCORD_URL} target={'_blank'} rel="noreferrer">
                      <DiscordIcon height={30} width={30}/>
                    </a>
                    </Col>
                    <Col>
                      <a className={'menu-link'} href={REACT_APP_TWITTER_URL} target={'_blank'} rel="noreferrer">
                        <TwitterIcon height={30} width={30}/>
                      </a>
                    </Col>
                  </Space>
                </Row>
              </Col>
              <Col>
                {store.isConnected && <NavLink to={'/my-wallet'}
                                               rel="noreferrer"
                                               className={({ isActive }) =>
                                                 isActive ? 'menu-link-active' : 'menu-link'
                                               }>
                  <Typography.Text>MY WALLET</Typography.Text>
                </NavLink>}
              </Col>
              <Col>
                <NavLink to={'/collections'}
                         rel="noreferrer"
                         className={({ isActive }) =>
                           isActive ? 'menu-link-active' : 'menu-link'
                         }>
                  <Typography.Text>BROWSE COLLECTIONS</Typography.Text>
                </NavLink>
              </Col>
              {store.isConnected && <>
                <Col>
                  <ConnectionIndicator/>
                </Col>
                <Col>
                  <SelectChain defaultValue={configProvider.getChainConfig().chainName}
                               chains={chains}
                               className={'chain-select'}
                               onChange={async (chain) => await onChangeChain(chain)}/>
                </Col>
              </>}
              <Col>
                {!store.isConnected && <SelectChain defaultValue={'CONNECT WALLET'}
                                                    chains={chains}
                                                    className={'chain-select connect'}
                                                    suffixIcon={
                                                      <Icon component={ConnectIconSvg}
                                                            style={{
                                                              fill: '#fff',
                                                              color: '#fff',
                                                              fontSize: '24px',
                                                              lineHeight: '24px',
                                                              verticalAlign: 'middle'
                                                            }}/>}
                                                    onChange={async (chain) => await onChangeChain(chain)}/>
                }
              </Col>
            </Space>
          </Row>
        </Col>
      </Row>
    </Header>)
})
